import type { FC } from "react";
import React from "react";

import { Loader, type LoaderProps } from "../../../Loader";

import type { PickOfUnion } from "../../../../types/react";
import type { ILoader } from "../../../Loader/types";

export const BUTTON_INLINE_LOADER_TEST_ID = "button-inline-loader-test-id";

type ButtonInlineLoaderProps = PickOfUnion<
    LoaderProps,
    "label" | "view" | "customColorsStyles"
> &
    Pick<ILoader, "size">;

export const ButtonInlineLoader: FC<ButtonInlineLoaderProps> = (props) => {
    return <Loader {...props} data-tsid={BUTTON_INLINE_LOADER_TEST_ID} />;
};

ButtonInlineLoader.displayName = "ButtonInline.Loader";

export default ButtonInlineLoader;
